export default "/8b00e9f5b31d70962f6bb43984d1b17a.svg";